import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';

const MiamiLakesVzCoffeeEventFireStation = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        backgroundColor: '#fff',
        minHeight: '100vh',
        maxWidth: 900,
        mx: 'auto',
      }}
    >
      <Typography variant="h3" gutterBottom>
        Outreach efforts continue at Miami Lakes Farmers Market and Coffee Event at Fire Station
      </Typography>

      <Typography paragraph>
 This past Saturday, August 16th, the Town of Miami Lakes Vision Zero team attended two community events to support the outreach for the Vision Zero initiative. The first of these events being the monthly Farmer’s Market, held its kick-off for Vision Zero last month. The purpose of this event was to continue to educate residents about the Vision Zero concept, and to continue to conduct surveys on how the residents feel about the current safety of the town and how it can be improved.
      </Typography>

      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-firestation-event1.jpg`}
        alt="Vision Zero Kickoff Event 1"
        sx={{ width: '100%', borderRadius: 2, my: 3 }}
      />

      <Typography paragraph>
During the event, over 10 surveys were collected in both English and Spanish that highlighted the residents concerns about safety within the town of Miami Lakes. Information on traffic safety, as well as magnets, reflective wristbands, and bicycle helmets were distributed.
      </Typography>

      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-firestation-event2.jpg`}
        alt="Vision Zero Kickoff Event 2"
        sx={{ width: '100%', borderRadius: 2, my: 3 }}
      />

      <Typography paragraph>
 The main concern voiced by residents was the prevalence of speeding throughout the town. Many of the residents felt safe in Miami Lakes, but the reducing speeding would further increase the feeling of safety. With properly designed, safe and accessible infrastructure, every resident and every road user will feel safe traveling anywhere, by any method in Miami Lakes.
      </Typography>

      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-firestation-event3.jpg`}
        alt="Vision Zero Kickoff Event 3"
        sx={{ width: '100%', borderRadius: 2, my: 3 }}
      />

<Typography paragraph>
  While the Farmer’s Market was in full swing, the Town of Miami Lakes joined the
  Community Coffee event at Fire Station No. 64, continuing its commitment to Vision Zero.
  Hosted by the Fire Department, this welcoming and community-driven event encouraged residents
  to get involved by completing a community survey and contributing to a community map that
  highlights local safety concerns and ideas.
</Typography>

<Typography paragraph>
  The turnout was enthusiastic: 20 surveys were completed, and 8 helmets were distributed
  to promote safe cycling and active transportation.
</Typography>

<Typography paragraph>
  Among the attendees were members of the Elderly Affairs Committee, who voiced thoughtful
  concerns about how the town’s aging population may be contributing to traffic incidents.
  Their input added an important perspective to the conversation around safety and mobility.
</Typography>

<Typography paragraph>
  To continue the dialogue, the team reminded everyone that a special presentation will be held
  at the upcoming Senior Luncheon on Thursday, August 21st, where these issues will be explored
  in more detail.
</Typography>


      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-firestation-event4.jpg`}
        alt="Vision Zero Kickoff Event 3"
        sx={{ width: '100%', borderRadius: 2, my: 3 }}
      />

            <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-firestation-event5.jpg`}
        alt="Vision Zero Kickoff Event 3"
        sx={{ width: '100%', borderRadius: 2, my: 3 }}
      />

      <Typography paragraph>
        We invite you to continue participating as this public engagement effort just started. Join
        the conversation through our social media channels.
      </Typography>

<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <InstagramIcon color="action" />
    <Link
      href="https://www.instagram.com/miamilakesvisionzero"
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      color="inherit"
      sx={{ fontWeight: 500 }}
    >
      @miamilakesvisionzero
    </Link>
  </Box>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <XIcon color="action" />
    <Link
      href="https://twitter.com/miamilakesvz"
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      color="inherit"
      sx={{ fontWeight: 500 }}
    >
      @miamilakesvz
    </Link>
  </Box>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <FacebookIcon color="action" />
    <Link
      href="https://www.facebook.com/share/1HS7Sy2A9Z/?mibextid=wwXIfr"
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      color="inherit"
      sx={{ fontWeight: 500 }}
    >
      Vision Zero Miami Lakes
    </Link>
  </Box>
</Box>


<Typography paragraph>
  Be part of the conversation and participate by completing the community 
  survey using{' '}
  <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
    this survey link
  </Link>
  .
</Typography>

<Typography paragraph>
  Our website and social media channel continue posting project updates and upcoming events. 
</Typography>

<Typography paragraph>
  Para español:{' '}
  <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
    haga clic aquí
  </Link>{' '}
  (seleccione español)
</Typography>


    </Box>
  );
};

export default MiamiLakesVzCoffeeEventFireStation;
